import React from 'react'
import NavBar from '../Components/NavBar/NavBar'
import CategoryPageContent from '../Components/CategoryPageContent/CategoryPageContent'
import Footer from '../Components/Footer/Footer'
const CategoryPage = () => {
  return (
    <div className='overflow-x-hidden'>
      <NavBar/>
      <CategoryPageContent/>
      <Footer/>
    </div>
  )
}

export default CategoryPage
